interface MapTypeToggleProps {
  readonly mapType: 'street' | 'satellite'
  readonly onMapTypeChange?: (mapType: 'street' | 'satellite') => void
}

export function MapTypeToggle({
  mapType,
  onMapTypeChange,
}: MapTypeToggleProps) {
  if (!onMapTypeChange) return null

  const nextType = mapType === 'satellite' ? 'street' : 'satellite'
  const title =
    mapType === 'satellite'
      ? 'Switch to Street View'
      : 'Switch to Satellite View'

  return (
    <button
      onClick={() => onMapTypeChange(nextType)}
      className='hidden lg:flex absolute top-2.5 left-2.5 z-[1000] bg-white hover:bg-gray-50 border border-gray-300 rounded-lg shadow-lg px-4 py-2.5 items-center gap-2 text-sm font-semibold text-gray-700 transition-colors pointer-events-auto'
      title={title}
    >
      {mapType === 'satellite' ? (
        <>
          <svg
            className='w-4 h-4 sm:w-5 sm:h-5'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7'
            />
          </svg>
          <span className='hidden sm:inline'>Street View</span>
          <span className='sm:hidden'>Street</span>
        </>
      ) : (
        <>
          <svg
            className='w-4 h-4 sm:w-5 sm:h-5'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
          <span>Satellite View</span>
        </>
      )}
    </button>
  )
}
